<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<div
					:class="[
						'card',
						'card-border-color',
						'card-border-color-primary',
						'be-loading',
						{ 'be-loading-active': isBusy },
					]"
				>
					<div class="card-header">Order # {{ order.orderNumber }}</div>
					<div class="card-body">
						<form>
							<div class="form-group row">
								<label class="col-12 col-sm-3 col-form-label text-sm-right"
									>Order From</label
								>
								<div class="col-12 col-sm-8 col-lg-6">
									<select placeholder="Select a seller" v-model="sellerId">
										<option
											v-for="s in order.sellers"
											:key="s.id"
											:value="s.id"
										>
											{{ s.name }}
										</option>
									</select>
									<ul v-if="v1.sellerId" class="parsley-errors-list filled">
										<li class="parsley-required">Required.</li>
									</ul>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-12 col-sm-3 col-form-label text-sm-right"
									>Delivery Address --</label
								>
								<div class="col-12 col-sm-8 col-lg-6">
									<textarea
										class="form-control"
										placeholder="Delivery address for this order"
										v-model="deliveryAddress"
									></textarea>
									<ul
										v-if="v1.deliveryAddress"
										class="parsley-errors-list filled"
									>
										<li class="parsley-required">Required.</li>
									</ul>
								</div>
							</div>
						</form>
					</div>
					<div class="be-spinner">
						<svg width="40px" height="40px" viewBox="0 0 66 66">
							<circle
								class="circle"
								fill="none"
								stroke-width="4"
								stroke-linecap="round"
								cx="33"
								cy="33"
								r="30"
							></circle>
						</svg>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="showDetails">
			<div class="col-lg-12">
				<div
					:class="[
						'card',
						'card-border-color',
						'card-border-color-primary',
						'be-loading',
						{ 'be-loading-active': isBusy },
					]"
				>
					<div class="card-heade p-2">
						<button
							class="btn btn-success btn-rounded btn-space float-right"
							@click="viewAdd"
						>
							<span class="icon icon-left mdi mdi-plus"></span> Add item
						</button>
						<h4><strong>Order Details</strong></h4>
					</div>

					<div class="col-sm-12 table-responsive">
						<table class="table table-fw-widget dataTable no-footer">
							<thead>
								<tr>
									<th style="width: 45%">Description</th>
									<th style="width: 15%">Quantity</th>
									<th style="width: 15%">Unit Price</th>
									<th style="width: 25%">Total</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in orderDetails" :key="index">
									<td>
										{{ item.name }} ({{ item.code }}) - N{{ item.unitPrice }}/{{
											item.unit
										}}
									</td>
									<td>{{ item.quantity }}</td>
									<td>&#8358; {{ formatMoney(item.unitPrice) }}</td>
									<td>
										<button
											class="
                        btn btn-secondary btn-rounded btn-space
                        float-right
                      "
											@click.prevent="remove(index)"
										>
											Remove
										</button>
										&#8358; {{ formatMoney(item.quantity * item.unitPrice) }}
									</td>
								</tr>
								<tr v-if="!orderDetails.length">
									<td colspan="4">
										<div class="text-center">No items in order</div>
									</td>
								</tr>
								<tr>
									<td colspan="2"></td>
									<td class="text-right">
										<b>SUBTOTAL</b>
									</td>
									<td>&#8358; {{ formatMoney(subtotal) }}</td>
								</tr>
								<tr>
									<td colspan="2"></td>
									<td class="text-right">
										<b>DISCOUNT</b>
									</td>
									<td>&#8358; {{ formatMoney(discount) }}</td>
								</tr>

								<tr>
									<td colspan="2"></td>
									<td class="text-right">
										<b>BALANCE</b>
									</td>
									<td>&#8358; {{ formatMoney(total) }}</td>
								</tr>
							</tbody>
						</table>
						<div class="row mt-5 justify-content-end">
							<div class="col-12 col-sm-3 col-lg-3 mt-1">
								<button
									:disabled="isBusyFull || !orderDetails.length"
									class="btn btn-success btn-xl btn-block"
									@click.prevent="showConfirm"
								>
									<span v-if="isBusyFull">Busy...</span>
									<span v-else>Place Order and Pay</span>
								</button>
							</div>
							<div class="col-12 col-sm-2 col-lg-2 mt-1">
								<button
									:disabled="isBusy || !orderDetails.length"
									class="btn btn-primary btn-xl btn-block"
									@click.prevent="makeOrder('placeOrder')"
								>
									<span v-if="isBusy">Busy...</span>
									<span v-else>Place Order</span>
								</button>
							</div>
							<div class="col-12 col-sm-2 col-lg-2 mt-1">
								<button
									:disabled="isDraftBusy || !orderDetails.length"
									class="btn btn-secondary btn-xl btn-block"
									@click.prevent="makeDraftOrder"
								>
									<span v-if="isDraftBusy">Busy...</span>
									<span v-else>Save to Drafts</span>
								</button>
							</div>
						</div>
					</div>
					<div class="card-body" v-if="orderDetails.length">
						<div class="form-group row" v-if="order.creditLimit > 0">
							<div class="col-2 col-sm-2 col-lg-2">
								<label class="custom-control custom-checkbox custom-control-inline">
									<input
										class="custom-control-input"
										type="checkbox"
										v-model="useCredit"
									/>
									<span class="custom-control-label">
										Use credit facilities. Your current balance is
										<b>&#8358; {{ formatMoney(order.creditLimit) }}</b>
									</span>
								</label>
							</div>
						</div>
					</div>
					<div class="be-spinner">
						<svg width="40px" height="40px" viewBox="0 0 66 66">
							<circle
								class="circle"
								fill="none"
								stroke-width="4"
								stroke-linecap="round"
								cx="33"
								cy="33"
								r="30"
							></circle>
						</svg>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade colored-header colored-header-primary" id="mod-add" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header modal-header-colored">
						<h3 class="modal-title">Add item to list</h3>
						<button
							class="close md-close"
							type="button"
							data-dismiss="modal"
							aria-hidden="true"
						>
							<span class="mdi mdi-close"></span>
						</button>
					</div>
					<div class="modal-body">
						<div v-for="(list, index) in productList" :key="index">
							<div class="row">
								<div class="col col-10">
									<div class="form-group row">
										<label class="col-12 col-sm-3 col-form-label text-sm-right"
											>Product</label
										>
										<div class="col-12 col-sm-8 col-lg-8">
											<select
												placeholder="Select an option"
												class="form-control"
												v-model="list.productIndex"
											>
												<option disabled v-if="!filteredProducts.length"
													>No product available</option
												>
												<option
													v-for="(p, index) in filteredProducts"
													:key="p.id"
													:value="index"
												>
													{{ p.name }} ({{ p.code }}) - N{{
														formatMoney(p.retailPrice)
													}}/{{ p.unit }}
												</option>
											</select>
											<ul
												v-if="list.piError"
												class="parsley-errors-list filled"
											>
												<li class="parsley-required">Required.</li>
											</ul>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-12 col-sm-3 col-form-label text-sm-right"
											>Quantity</label
										>
										<div class="col-12 col-sm-8 col-lg-8">
											<input
												:class="[
													'form-control',
													{ 'is-invalid': list.qError },
												]"
												type="number"
												v-model="list.quantity"
											/>
											<ul
												v-if="list.qError"
												class="parsley-errors-list filled"
											>
												<li class="parsley-required">
													Enter a number > 0.
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="col col-2">
									<div class="delete-list">
										<span
											@click="deleteProductList(index)"
											style="color:red;cursor:pointer"
											class="mdi mdi-close"
										></span>
									</div>
								</div>
							</div>
						</div>

						<div>
							<button
								@click="addProductList"
								type="button"
								class="btn btn-text"
								style="color:#766cea"
							>
								<span class="mdi mdi-plus"></span>
								Add another item
							</button>
						</div>
						<!-- <div class="form-group row">
							<label class="col-12 col-sm-3 col-form-label text-sm-right"
								>Product</label
							>
							<div class="col-12 col-sm-8 col-lg-8">
								<select
									placeholder="Select an option"
									class="form-control"
									v-model="newItem.productIndex"
								>
									<option disabled v-if="!filteredProducts.length"
										>No product available</option
									>
									<option
										v-for="(p, index) in filteredProducts"
										:key="p.id"
										:value="index"
									>
										{{ p.name }} ({{ p.code }}) - N{{
											formatMoney(p.retailPrice)
										}}/{{ p.manufacturerProduct.unit }}
									</option>
								</select>
								<ul v-if="v2.productId" class="parsley-errors-list filled">
									<li class="parsley-required">Required.</li>
								</ul>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-12 col-sm-3 col-form-label text-sm-right"
								>Quantity</label
							>
							<div class="col-12 col-sm-8 col-lg-8">
								<input
									:class="['form-control', { 'is-invalid': v2.quantity }]"
									type="number"
									v-model="newItem.quantity"
								/>
								<ul v-if="v2.quantity" class="parsley-errors-list filled">
									<li class="parsley-required">Enter a number > 0.</li>
								</ul>
							</div>
						</div> -->
					</div>
					<div class="modal-footer">
						<button
							style="width: 100px"
							class="btn btn-secondary"
							type="button"
							data-dismiss="modal"
						>
							Cancel
						</button>
						<button
							style="width: 100px"
							:disabled="isBusyModal"
							class="btn btn-primary"
							type="button"
							@click.prevent="add"
						>
							<span v-if="isBusyModal">Busy...</span>
							<span v-else>Done</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<confirm-payment-modal
			:modalName="modalName"
			@proceed="makeOrder"
			:order="modalOrder"
			:transactionFee="txFee"
			:totalFee="totalFee"
			:isBusy="isBusyFull"
			@cancel="cancelConfirm"
		></confirm-payment-modal>

		<payment-status-modal
			:isPosting="isBusyModal"
			:status="orderPaymentStatus"
			:statusMsg="orderPaymentStatusMsg"
			@retryPayment="retryPayment"
			:isFromCreate="isFromCreate"
		></payment-status-modal>
	</div>
</template>

<script>
	/* eslint-disable */

	import { helper } from "@/helper";
	import Select2 from "@/components/Select2";
	import ConfirmPaymentModal from "@/components/Order/ConfirmPaymentModal";
	import PaymentStatusModal from "@/components/Order/PaymentStatusModal";

	Array.prototype.sum = function(prop1, prop2) {
		var total = 0;
		for (var i = 0, _len = this.length; i < _len; i++) {
			total += this[i][prop1] * this[i][prop2];
		}
		return total;
	};

	export default {
		name: "ordersCreate",
		components: {
			Select2,
			ConfirmPaymentModal,
			PaymentStatusModal,
		},

		data() {
			return {
				modalName: "",
				showDetails: false,
				isBusy: false,
				isDraftBusy: false,
				isBusyFull: false,
				isBusyModal: false,
				order: {},
				sellerId: null,
				deliveryAddress: null,
				products: [],
				filteredProducts: [],
				productList: [
					{
						productIndex: null,
						piError: false,
						quantity: 0,
						qError: false,
					},
				],
				orderDetails: [],
				discount: 0.0,
				tax: 0.0,
				subtotal: 0.0,
				total: 0.0,
				useCredit: false,
				newItem: {},
				v1: {
					sellerId: false,
					deliveryAddress: false,
				},
				v2: {
					productId: false,
					quantity: false,
				},
				discountObj: null,
				retryOrderPayload: null,
				orderPaymentStatus: null,
				orderPaymentStatusMsg: "",
				isFromCreate: false,
				txFee:"",
				totalFee:"",
				modalOrder: null
			};
		},

		created() {
			this.sellerId = this.$route.query.distributor;
			this.initialize();
		},

		computed: {
			user: function() {
				return this.$store.state.currentUser;
			},
		},

		watch: {
			sellerId: function(newVal, oldVal) {
				this.onSellerChange(newVal);
			},

			orderDetails: function(newVal, oldVal) {
				this.subtotal = this.orderDetails.sum("quantity", "unitPrice");
				this.discount = 0;

				if (this.discountObj) {
					this.discount =
						this.discountObj.type == "Percent"
							? this.subtotal * (this.discountObj.value / 100)
							: this.discountObj.value;
				}

				this.tax = 0;
				this.total = this.subtotal - this.tax - this.discount;
			},
		},

		methods: {
			async initialize() {
				this.isBusy = true;

				await this.$http
					.get("/Orders/initialize")
					.then(function(res) {
						this.order = res.body;
						this.deliveryAddress = res.body.buyer.deliveryAddress;
						this.isBusy = false;
					})
					.catch(function() {
						this.$router.push("/merchant/orders");
					});
			},

			viewAdd() {
				(this.productList = [
					{
						productIndex: null,
						piError: false,
						quantity: 0,
						qError: false,
					},
				]),
					(this.newItem = {
						productIndex: null,
						quantity: null,
					});

				this.v2 = {
					productId: false,
					quantity: false,
				};

				var fProducts = [];

				var details = this.orderDetails;

				this.products.forEach(function(e) {
					if (!details.some(s => s.code == e.code)) {
						fProducts.push(e);
					}
				});

				this.filteredProducts = fProducts;

				$("#mod-add").modal("show");
			},

			addProductList() {
				this.productList.push({
					productIndex: null,
					piError: false,
					quantity: 0,
					qError: false,
				});
			},

			deleteProductList(index) {
				this.productList.splice(index, 1);
			},

			add() {
				if (this.validateAdd()) {
					for (var i = 0; i < this.productList.length; i++) {
						var p = {
							name: this.filteredProducts[this.productList[i].productIndex].name,
							unit: this.filteredProducts[this.productList[i].productIndex].unit,
							code: this.filteredProducts[this.productList[i].productIndex].code,
							description: `${
								this.filteredProducts[this.productList[i].productIndex].name
							} (${this.filteredProducts[this.productList[i].productIndex].unit})`,
							unitPrice: this.filteredProducts[this.productList[i].productIndex]
								.retailPrice,
							quantity: this.productList[i].quantity,
						};

						this.orderDetails.push(p);
					}
					$("#mod-add").modal("hide");
				}
			},

			validateAdd() {
				this.v2 = {
					productId: false,
					quantity: false,
				};
				var isValid = true;
				let firstProductName = "";

				for (var i = 0; i < this.productList.length; i++) {
					if (this.productList.length > 0)
						firstProductName = this.filteredProducts[this.productList[0].productIndex]
							.name;

					if (firstProductName !== "" && i > 0) {
						if (
							firstProductName ===
							this.filteredProducts[this.productList[i].productIndex].name
						) {
							this.$toast.warning("You cannot add list of the same product", {
								icon: true,
								rtl: false,
							});
							return (isValid = false);
						}
					}

					if (this.productList[i].productIndex === null) {
						this.productList[i].piError = true;
						isValid = false;
					}

					if (Number(this.productList[i].quantity) <= 0) {
						this.productList[i].qError = true;
						isValid = false;
					}
				}

				// if (this.newItem.productIndex < 0) {
				// 	this.v2.productId = true;
				// 	isValid = false;
				// }

				// if (Number(this.newItem.quantity) <= 0) {
				// 	this.v2.quantity = true;
				// 	isValid = false;
				// }

				return isValid;
			},

			onSellerChange(id) {
				this.showDetails = true;
				this.orderDetails = [];
				this.getProducts(id);
				this.getDiscount();
			},

			async getProducts(parentId) {
				this.products = [];

				await this.$http
					.get(
						"/Products/getListNoPagingForDistributor?parentId=" +
							parentId +
							"&active=true",
					)
					.then(function(res) {
						this.products = res.body;
					})
					.catch(function() {});
			},

			remove(index) {
				this.orderDetails.splice(index, 1);
			},

			updateStatus() {
				$("#mod-change").modal("hide");
			},

			cancelConfirm() {
				$("#mod-confirm-payment").modal("hide");
			},

			async showConfirm() {
				this.modalName = "confirm order payment";
				let sellerName = this.order.sellers.find(item => item.id === this.sellerId).name;
				this.modalOrder={
					total: this.total,
					totalAmountPaid:0,
					seller:{name: sellerName}
				}

				let payload ={
					distributorId: this.sellerId,
					amount: this.total
				}
				await this.$http
					.put("/Payments/calculatemerchantfee", payload)
						.then(function(res) {
						this.txFee = res.body.fee;
						this.totalFee = res.body.totalAmount;
						this.isBusyFull = false;
						$("#mod-confirm-payment").modal("show");
					})
					.catch(function() {});
			},

			async makeOrder(type) {
				if (this.orderDetails.length < 1) {
					return this.$toast.error("Please select at least one product", {
						icon: false,
						rtl: false,
					});
				}
				if (type === "placeOrder") {
					this.isBusy = true;
				} else {
					this.isBusyFull = true;
				}

				if (this.validateOrder()) {
					var data = {
						orderNumber: this.order.orderNumber,
						subtotal: this.subtotal,
						discount: this.discount,
						tax: this.tax,
						total: this.total,
						parentId: "N/A",
						sellerId: this.sellerId,
						makerId: this.user.id,
						details: this.orderDetails,
						useCredit: this.useCredit,
						deliveryAddress: this.deliveryAddress,
						isDraft: false,
					};

					if (type === "placeOrder") {
						await this.$http
							.post("/Orders/create", data)
							.then(function(res) {
								this.isBusy = false;
								this.isBusyFull = false;
								this.$router.push("/merchant/orders");
							})
							.catch(function() {});
					} else {
						const res = await this.$http
							.post("/Orders/create", data)
							.then(function(res) {
								// this.isBusy = false;
								// this.isBusyFull = false;
								return res;
							})
							.catch(function() {});

						if (res.ok) {
							// this.$router.push("/merchant/orders");
							// this.$router.push(`/merchant/orders/${res.body.id}`);
							const payload = {
								orderId: res.body.id,
								amount: res.body.total,
							};
							this.makePayment(payload);
						} else {
							this.isBusy = false;
						}
					}
				}
			},

			async makePayment(payload) {
				// if (isPartPayment) {
				// 	this.isBusyModal = true;
				// } else {
				// 	this.isBusyFull = true;
				// }

				// const payload = {
				// 	orderId: this.order.id,
				// 	amount: isPartPayment ? +amt : +this.order.total,
				// };
				this.retryOrderPayload = payload;
				await this.$http
					.post("/Payments/makePayment", payload)
					.then(function(res) {
						if (res.ok) {
							this.isFromCreate = true;
							this.isBusyModal = false;
							this.isBusyFull = false;
							this.isBusy = false;

							this.cancelConfirm();
							if (
								res.body &&
								res.body.status != null &&
								res.body.status === "Successful"
							) {
								this.orderPaymentStatus = "success";
								this.orderPaymentStatusMsg = res.body.message;
								this.retryOrderPayload = {};
								this.showPaymentStatusModal();
								// this.$router.push("/merchant/orders");
							} else if (
								res.body &&
								res.body.status != null &&
								(res.body.status === "Failed" || res.body.status === "failed")
							) {
								this.orderPaymentStatus = "fail";
								this.orderPaymentStatusMsg = res.body.message;
								this.showPaymentStatusModal();
								// this.$router.push("/merchant/orders");
							} else if (
								res.body &&
								res.body.status != null &&
								res.body.status === "WaitingForOtp"
							) {
								this.orderPaymentStatus = "warning";
								this.orderPaymentStatusMsg = res.body.message
									? res.body.message
									: "Waiting for otp";
								this.showPaymentStatusModal();
								// this.$router.push("/merchant/orders");
							} else {
								this.orderPaymentStatus = "fail";
								this.orderPaymentStatusMsg = "something went wrong";
								this.showPaymentStatusModal();
								// this.$router.push("/merchant/orders");
							}
							// this.$router.push("/merchant/orders");
						}
					})
					.catch(function() {
						this.isBusyModal = false;
						this.isBusyFull = false;
						this.isFromCreate = true;
						this.orderPaymentStatus = "fail";
						this.isBusy = false;
						this.cancelConfirm();
						this.showPaymentStatusModal();
					});
				this.isBusyModal = false;
				this.isBusyFull = false;
			},

			async retryPayment() {
				this.isBusyModal = true;
				await this.$http
					.post("/Payments/makePayment", this.retryOrderPayload)
					.then(function(res) {
						if (res.ok) {
							this.isBusyModal = false;
							this.isBusyFull = false;
							this.isFromCreate = true;
							this.closePartPaymentModal();
							if (
								res.body &&
								res.body.status != null &&
								res.body.status === "Successful"
							) {
								this.orderPaymentStatus = "success";
								this.orderPaymentStatusMsg = res.body.message;
								this.retryOrderPayload = {};
								setTimeout(() => this.showPaymentStatusModal(), 1000);
								// this.$router.push("/merchant/orders");
							} else if (
								res.body &&
								res.body.status != null &&
								(res.body.status === "Failed" || res.body.status === "failed")
							) {
								this.orderPaymentStatus = "fail";
								this.orderPaymentStatusMsg = res.body.message;
								setTimeout(() => this.showPaymentStatusModal(), 1000);
								// this.$router.push("/merchant/orders");
							} else if (
								res.body &&
								res.body.status != null &&
								res.body.status === "WaitingForOtp"
							) {
								this.orderPaymentStatus = "warning";
								this.orderPaymentStatusMsg = res.body.message
									? res.body.message
									: "Waiting for otp";
								setTimeout(() => this.showPaymentStatusModal(), 1000);
								// this.$router.push("/merchant/orders");
							} else {
								this.orderPaymentStatus = "fail";
								this.orderPaymentStatusMsg = "something went wrong.";
								setTimeout(() => this.showPaymentStatusModal(), 1000);
								// this.$router.push("/merchant/orders");
							}
						}
					})
					.catch(function() {
						this.isBusyModal = false;
						this.isBusyFull = false;
						this.isFromCreate = true;
						this.orderPaymentStatus = "fail";
						this.showPaymentStatusModal();
					});
				this.isBusyModal = false;
			},

			showPaymentStatusModal() {
				$("#mod-payment-status").modal("show");
			},

			async makeDraftOrder() {
				this.isDraftBusy = true;

				if (this.validateOrder()) {
					var data = {
						orderNumber: this.order.orderNumber,
						subtotal: this.subtotal,
						discount: this.discount,
						tax: this.tax,
						total: this.total,
						parentId: "N/A",
						sellerId: this.sellerId,
						makerId: this.user.id,
						details: this.orderDetails,
						useCredit: this.useCredit,
						deliveryAddress: this.deliveryAddress,
						isDraft: true,
					};

					await this.$http
						.post("/Orders/create", data)
						.then(function(res) {
							this.isBusy = false;
							this.$router.push("/merchant/drafts");
						})
						.catch(function() {});
					this.isDraftBusy = false;
				} else {
					this.isDraftBusy = false;
				}
			},

			validateOrder() {
				this.v1 = {
					sellerId: false,
					deliveryAddress: false,
				};
				var isValid = true;

				if (!this.sellerId) {
					this.v1.sellerIs = true;
					isValid = false;
				}

				if (!this.deliveryAddress) {
					this.v1.deliveryAddress = true;
					isValid = false;
				}

				return isValid;
			},

			formatMoney(val) {
				return helper.formatMoney(val);
			},

			async getDiscount() {
				await this.$http
					.get(
						"/Discounts/getForOrder?buyerId=" +
							this.user.id +
							"&sellerId=" +
							this.sellerId,
					)
					.then(function(res) {
						if (res.body === "") return (this.discountObj = null);
						this.discountObj = res.body;
					})
					.catch(function() {});
			},
		},
	};
</script>

<style scoped>
	/* .delete-list{
		position:absolute;
		top: 10px;
		right: 20px;
	} */
</style>
